import { withInstall } from '@fx-front-framework/utils/with-install'
import VModal from './src/index.vue'

export const FxVModal = withInstall(VModal)
export default FxVModal
